module.exports = __webpack_public_path__ + "img/icon_attention.22eaded5.svg";